import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { NgxMaskDirective } from 'ngx-mask';
import { User } from '../../../../core/models/user.model';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    NgxMaskDirective
  ],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
  registerForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService,
    private notification: NotificationService
  ) {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
      terms: [false, [Validators.requiredTrue]]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { mismatch: true };
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    if (this.registerForm.valid) {
      const payload: User = {
        name: this.registerForm.value.name,
        email: (this.registerForm.value.email ?? '').trim().toLowerCase(),
        phone: this.registerForm.value.phone,
        cpf: this.registerForm.value.cpf,
        password: this.registerForm.value.password
      };

      this.authService.register(payload).subscribe({
        next: () => {
          this.notification.success('Cadastro realizado com sucesso! Faça login para continuar.');
          this.router.navigate(['/auth/login']);
        },
        error: (err: any) => {
          const backendMessage =
            err?.error?.message ||
            err?.error?.error ||
            err?.error?.details?.[0]?.message;

          if (backendMessage) {
            this.notification.error(backendMessage);
            return;
          }

          if (err?.status === 403) {
            this.notification.error('Cadastro bloqueado pela API (403). Verifique se o endpoint /users está público no backend.');
            return;
          }

          this.notification.error(`Erro ao realizar cadastro${err?.status ? ` (HTTP ${err.status})` : ''}.`);
        }
      });
    }
  }
}
